/**
 * ログイン用の検索パラメータです。
 */
export interface LoginSearchParams {
  /** エラー */
  error: string | null;
  /** コード */
  code: string | null;
  /** 次回アクセスパス */
  state: string | null;
}

/**
 * URLの検索クエリを解析し、ログイン検索パラメータに変換します。
 * @param search - 検索クエリ
 * @returns ログイン検索パラメータ
 */
export const getLoginSearchParams = (search: string): LoginSearchParams => {
  const urlSearchParams = new URLSearchParams(search);
  return {
    error: urlSearchParams.get("error"),
    code: urlSearchParams.get("code"),
    state: urlSearchParams.get("state"),
  };
};
